import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconLeft from "@arco-design/web-react/icon/react-icon/IconLeft";
import React from 'react';
import { useHistory } from 'react-router-dom';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const overviewChart = `graph TD
    A["① 录入销售订单\\n或需求单"] --> B["② 系统自动算料\\nMRP"]
    B --> C["③ 生成采购任务"]
    B --> D["④ 生成生产工单"]

    C --> E["⑤ 询价/比价/竞价"]
    E --> F["⑥ 采购下单"]
    F --> G["⑦ 供应商确认\\n& 交期反馈"]

    G --> H["⑧ 供应商发货"]
    H --> I["⑨ 扫码收货\\n& 品检"]
    I --> J["⑩ 合格品入库"]
    I --> K["⑪ 不合格品退货"]

    J --> L["⑫ 生产领料"]
    L --> M["⑬ 齐套分析"]
    M --> N["⑭ 车间领料生产"]
    N --> O["⑮ 成品入库"]

    J --> P["⑯ 销售出库"]

    O --> Q["⑰ 销售发货\\n给客户"]
    P --> Q

    J -.-> R["⑱ 与供应商对账"]
    R --> S["⑲ 付款结算"]

    style A fill:#E3F2FD,stroke:#2196F3
    style B fill:#FFF3E0,stroke:#FF9800
    style I fill:#FFEBEE,stroke:#F44336
    style L fill:#E8F5E9,stroke:#4CAF50
    style P fill:#FFF9C4,stroke:#FFC107
    style Q fill:#E8F5E9,stroke:#4CAF50
    style S fill:#F3E5F5,stroke:#9C27B0`;
export default function Overview() {
  const history = useHistory();
  return /*#__PURE__*/React.createElement("div", {
    className: styles['overview-page']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['overview-back']
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    icon: /*#__PURE__*/React.createElement(_IconLeft, null),
    onClick: () => history.push('/help')
  }, "\u8FD4\u56DE\u5E2E\u52A9\u4E2D\u5FC3")), /*#__PURE__*/React.createElement("h1", {
    className: styles['overview-page-title']
  }, "\u4E1A\u52A1\u5168\u666F\u56FE"), /*#__PURE__*/React.createElement("p", {
    className: styles['overview-page-desc']
  }, "\u8FD9\u662F\u7CFB\u7EDF\u7684\u5168\u8C8C\u3002\u4E0D\u7BA1\u4F60\u662F\u54EA\u4E2A\u89D2\u8272\uFF0C\u770B\u61C2\u8FD9\u5F20\u56FE\u5C31\u77E5\u9053\u81EA\u5DF1\u7684\u6D3B\u513F\u5728\u54EA\u4E2A\u73AF\u8282\u3001\u4E0A\u4E0B\u6E38\u5728\u505A\u4EC0\u4E48\u3002"), /*#__PURE__*/React.createElement("div", {
    className: styles['overview-page-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: overviewChart
  })));
}